import { TypePolicies } from '@apollo/client';
import { ListUsersQueryVariables } from '../graphql/generated';
import { cacheMergePaginatedList } from './cache.util';

const UserCacheTypePolicies: TypePolicies = {
  Query: {
    fields: {
      listUsers: {
        keyArgs: ['input', []],
        merge: (existing, incoming, { variables }) => {
          return cacheMergePaginatedList<ListUsersQueryVariables>(
            existing,
            incoming,
            variables as ListUsersQueryVariables
          );
        },
      },
    },
  },
};

export { UserCacheTypePolicies };
